var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "16px",
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1BACA176-0B07-4E81-8D40-1E6C265A7D54") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "4e-05 0.0512608696 21.84204 0.0512608696 21.84204 14.2826087 4e-05 14.2826087"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Seamless-Checkout",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.00-Seleccionar-metodo",
    transform: "translate(-270.000000, -352.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(18.000000, 37.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    transform: "translate(22.000000, 298.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy",
    transform: "translate(230.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 0.046565)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.02974,10.9343837 L18.06084,11.9919815 L11.89114,11.9791663 L11.89114,7.12454674 L9.89164,7.12454674 L12.35524,1.65518804 L14.75394,1.65518804 L15.59644,3.52660109 L15.59644,1.65518804 L18.55774,1.65518804 L19.06844,3.05732935 L19.58084,1.65518804 L21.84204,1.65518804 L21.84204,0.741394565 C21.84204,0.36026413 21.52624,0.0512315217 21.13654,0.0512315217 L0.70554,0.0512315217 C0.31584,0.0512315217 4e-05,0.36026413 4e-05,0.741394565 L4e-05,13.5925141 C4e-05,13.9735467 0.31584,14.2826772 0.70554,14.2826772 L21.13654,14.2826772 C21.52624,14.2826772 21.84204,13.9735467 21.84204,13.5925141 L21.84204,11.9879707 L20.00574,11.9879707 L19.02974,10.9343837 Z",
    id: "Fill-1",
    fill: "#016FD0",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.97573,4.74926087 L13.55633,3.39182609 L14.13633,4.74926087 L12.97573,4.74926087 Z M20.04593,2.29529348 L19.07933,4.92309783 L18.11913,2.30155435 L16.25283,2.29529348 L16.25283,6.52001087 L14.34333,2.29588043 L12.80943,2.29588043 L10.87363,6.56011957 L12.20133,6.56011957 L12.56643,5.70629348 L14.54533,5.70629348 L14.91033,6.56011957 L16.27093,6.56011957 L16.27063,6.55943478 L17.42663,6.55943478 L17.42663,3.63032609 L18.54033,6.55943478 L19.59523,6.55943478 L20.68623,3.64030435 L20.68623,6.56941304 L21.84203,6.55943478 L21.84203,6.56501087 L21.84203,2.29529348 L20.04593,2.29529348 Z",
    id: "Fill-4",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25493,11.406737 L16.25493,10.4310196 L13.75343,10.4310196 L13.75343,9.77558478 L16.19523,9.77558478 L16.19523,8.80867174 L13.75343,8.80867174 L13.75343,8.1414 L16.25493,8.1414 L16.25493,7.17751957 L18.28333,9.28968261 L16.25493,11.406737 Z M19.07153,8.51088913 L17.82073,7.15824783 L16.25493,7.15824783 L16.25493,7.15815 L12.55583,7.15815 L12.55583,11.4260087 L16.23643,11.4260087 L17.77773,11.4260087 L19.03763,10.0597696 L20.31063,11.4260087 L21.84203,11.4260087 L21.84203,11.3654543 L19.83873,9.28968261 L21.84203,7.1919 L21.84203,7.15824783 L20.32583,7.15824783 L19.07153,8.51088913 Z",
    id: "Fill-6",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#016FD0",
    points: "21.74204 8.07587609 20.59194 9.27825652 21.74204 10.4915935"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAmex);
export default __webpack_public_path__ + "static/media/ic_amex.73e58381911602db6632154282e97ab4.svg";
export { ForwardRef as ReactComponent };